<template>
    <div id="bottom_wrapper">
      <SubscribeWidget/>
      <div id="comment-section">
        <b-container>
          <!-- comments list -->
          <h1>Say something!</h1>
          <!-- loop parent comments -->
          <div class="comment-parent" 
            v-for="(comment, index) in this.comments" 
            :key="index"
          >
            <div>
              <b-row class="comment-header">
                <b-col cols="4" class="comment-username">
                  <p>{{comment.name}}</p>
                </b-col>
                <b-col class="comment-date" cols="8">
                  <span>{{comment.dateAdded}}  </span>
                  <span v-if="comment.edited==true">(last edited: {{comment.dateEdited}})</span>
                </b-col>
                <b-col cols="1" v-if="ifCommentOwner(comment.email)">
                  <b-icon-trash
                    v-b-modal.modal-1
                    @click="requestDelete(index)"
                  ></b-icon-trash>
                  <!--                   v-on:click="deleteComment(index)" -->
                </b-col>
                <b-col cols="1" v-if="ifCommentOwner(comment.email)">
                  <b-icon-pencil v-on:click="requestEdit(index)"></b-icon-pencil>
                </b-col>
              </b-row>
            </div>
            <div class="comment-text">
              <p>{{comment.comment}}</p>
            </div>
          </div>

          <!-- verify subscriber -->
          <div v-if="!subscriber" class="comment-section-input">
            <p>If you're a subscriber:</p>
            <form>
              <div class="form-group">
                <label>Email address</label>
                <input type="email" v-model="email" class="form-control form-control-sm" />
              </div>
              <button type="button"  class="btn btn-dark btn-block" @click.prevent="isSubscriber">verify</button>
            </form>

            <p>Else, be a subscriber to post a comment</p>
          </div>

          <!-- if verified subscriber -->
          <div v-if="subscriber" class="comment-section-input">
            <b-form-textarea
              id="textarea"
              v-model="displayName"
              placeholder="AnonymusKnight (can be changed)"
              rows="1"
              max-rows="1"
              :disabled="commentIdxToEdit != null"
              class="comment-displayname"
            ></b-form-textarea>
            <b-form-textarea
              id="textarea"
              v-model="content"
              placeholder="Say something..."
              rows="3"
              max-rows="6"
              class="comment-content"
            ></b-form-textarea>
            <b-button class="my-auto" @click="addComment" v-if="!editingComment">send</b-button>
            <b-button class="my-auto" @click="editComment" v-if="editingComment">confirm edit</b-button>
          </div>
          <!-- Confirm comment delete modal -->
          <b-modal 
            id="modal-1" 
            v-model="showModal"
            @ok="acceptDelete"
            hide-header="true"
          >
            <p class="my-4">Are you sure you want to delete this comment?</p>
          </b-modal>
        </b-container>
      </div>
    </div>
</template>


<script>
import {db} from '@/firebase/init'
import { BIconPencil, BIconTrash } from 'bootstrap-vue'
import SubscribeWidget from '@/components/SubscribeWidget'
import postscribe from 'postscribe';
import $ from 'jquery'

export default {
  name: 'CommentSection',
  props: { // kapag galing na sa ComicReader
    comments: {
      type: Array,
    },
    chapterid: {
      type: String
    },
    pageNum: {
      type: Number,
    },
  },
  watch: {
    pageNum: {
      handler() {
        this.getPageComments();
      }
    },
  },
  components: {
    BIconTrash,
    BIconPencil,
    SubscribeWidget
  },
  data(){
    return{
      editingComment: false,
      showModal: false, // boolean to show/hide modal
      commentIdxToDelete: null, // index of comment (used by deleteComment())
      commentIdxToEdit: null,
      subscriber: false, // true if subscriber has been verified from the server
      email: "", // email of the subscriber
      displayName: "", // username of the subscriber
      content: "", // content of comment box text area
    }
  },
  methods: {
    isSubscriber(){
      var found = 0
      db.collection('subscribers')
      .get()
      .then(docs =>{
        // console.log(docs)
        /*
        refacor later to O(1) instead of O(n)
        */
        docs.forEach(doc =>{
          if(this.email==doc.data().email || this.email=='luny.kotwc2gmail.com'){
            found = 1;
          }
        })
      })
      .then(()=>{
        // console.log(found)
        if(found==1){
          this.subscriber = true;
          // console.log('Email is a subscriber')
        }
        // else{
          // console.log('Email is not a subscriber')
        // }
      })
    },
    /* show modal to confirm delete
       index: index of comment from comments list
       index of interest is stored to be used by deleteComment()
    */
    requestDelete(index) {
      this.commentIdxToDelete = index;
      this.showModal = true;
    },
    /* triggers deleteComment() when modal-footer Ok button is clicked.
    */
    acceptDelete() {
      this.deleteComment(this.commentIdxToDelete);
    },
    addComment(){
      //check if display name is added
      if (this.displayName=="") {
        this.displayName = "AnonymusKnight";
      }

      // updated date string here
      var d = new Date()
      var date = d.toDateString()
      //console.log(date)
      
      if (this.subscriber==true) {
        // construct comment object
        var newComment = {
          email: this.email,
          name: this.displayName,
          comment: this.content, 
          dateAdded: date,
          edited: false
        }

        // Firebase Query
        // Get document of the current page
        db.collection('comics')
        .doc(this.chapterid)
        // .doc('chapter3')
        .collection('pages')
        .where('pageNum', '==', this.pageNum)
        // .where('pageNum', '==', 2)
        .limit(1)
        .get()
        .then((query) =>{
          // modify document of current page
          const doc = query.docs[0]
          doc.ref.update({
            comments: this.comments
          }).then(()=>{
            // console.log('Added comment');
          }).catch(err => {
            throw err;
          })
        })
        // push comment to comments list
        this.comments.push(newComment);

        // reset comment text area to empty string
        this.resetCommentBox();
      } else {
        // console.log('No permission to add comment');
      }
    },
    deleteComment(index) {
        //only admin(luny) or original poster can delete comment
        if((this.subscriber==true && this.email==this.comments[index].email) || this.email=='luny.kotwc@gmail.com'){

          this.$delete(this.comments, index)
          
          db.collection('comics')
          .doc(this.chapterid)
          .collection('pages')
          .where('pageNum', '==', this.pageNum)
          .limit(1)
          .get()
          .then((query) =>{
            const doc = query.docs[0]
            doc.ref.update({
              comments: this.comments
            }).then(()=>{
              // console.log('Comment deleted');
              // console.log('Comments left = ' + this.comments.length)
              // need to reload comment section
            }).catch(err => {
              throw err;
            })
          })
        } 
        // else {
        //   console.log('No permission to delete comment');
        // }
    },
    editComment(){
      // edit date
      const d = new Date()
      const date = d.toDateString()
      // console.log(date)

      // load comment
      const commentToEdit = this.comments[this.commentIdxToEdit];

      if (this.subscriber==true && this.email==commentToEdit.email) {
        // update comment property
        commentToEdit.comment = this.content;
        // add date edited property
        commentToEdit.dateEdited = date;
        // add edited property
        commentToEdit.edited = true;

        // Firebase query
        db.collection('comics')
        .doc(this.chapterid)
        .collection('pages')
        .where('pageNum', '==', this.pageNum)
          .limit(1)
          .get()
          .then((query) =>{
            const doc = query.docs[0]
            doc.ref.update({
              comments: this.comments
            }).then(()=>{
              // console.log('Comment edited');
              // need to reload comment section
            }).catch(err => {
              throw err;
            })
          })
      } 
      // else {
      //   console.log('No permission to edit comment');
      // }

      // clean things up before exiting
      this.resetCommentBox();
      this.editingComment = false;
      this.commentIdxToEdit = null;
    },
    getPageComments(){
      db.collection('comics')
        .doc(this.chapterid)
        .collection('pages')
        .where('pageNum', '==', this.pageNum)
        .limit(1)
        .get()
        .then((query) =>{
          var commentDoc = query.docs[0].data()
          this.comments = commentDoc.comments
        })
        .catch(() => {
            this.comments = []
        })
    },
    resetCommentBox(){
      this.content = "";
    },
    ifCommentOwner(commentEmail) {
      if (commentEmail == this.email && this.subscriber == true) {
        return true
      }

      return false
    },
    requestEdit(index) {
      // set boolean to true to show appropriate button
      this.editingComment = true;

      // store index
      this.commentIdxToEdit = index;

      // load comment to UI
      const commentToEdit = this.comments[index];
      this.displayName = commentToEdit.name;
      this.content = commentToEdit.comment;
    },
  }, 
  created(){
    try{
      this.getPageComments();
    }catch(error){
      this.comments=[]
    }
  },
  mounted(){
    /*eslint-disable*/
      //console.log("Loading SFPortrait!")
      postscribe(document.body,'<script type="text/javascript" src="https://spiderforest.com/widgets/portrait-banner.php?g=false&id=ktwc%22%3E"><\/script>',{
          done: function(){
          $("#sf-banner-portrait").appendTo("#bottom_wrapper")
          //console.log("Loaded SFPortrait!")
          }
      })
    /*eslint-disable*/
  }
}
</script>

<style>
  #comment-section {
    background-color: rgb(53, 33, 59);
    color: whitesmoke;
    text-align: left;
    padding: 3px;
    border: 3px solid #733F53;
    flex: 1;
    margin-left: 5px;
    margin-right: 5px;
    height: 100%;
  }

  .comment-header {
    font-size: 16px;
  }

  .comment-username{
    font-size: 16px;
  }

  .comment-date {
    color: gray;
  }

  .comment-text {
    word-wrap:break-word;
  }

  .comment-parent{
    border-top: 3px solid #733F53;
    border-right: 3px solid #733F53;
    border-left: 3px solid #733F53;
    padding: 5px;
  }

  .comment-section-input{
    border-top: 3px solid #733F53;
    padding: 5px;
  }

  .comment-displayname{
    margin-bottom: 5px;
  }
  
  .comment-content{
    margin-bottom: 5px;
  }

  #bottom_wrapper{
    display: flex;
    align-items: top;
  }
</style>